var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/service_short_banner_logo.70d043aa.png","uri@2x": __webpack_public_path__ + "static/media/service_short_banner_logo.835723c5.png","uri@3x": __webpack_public_path__ + "static/media/service_short_banner_logo.03719cda.png",
    width: 20,
    height: 23
});